export class ProcessedCash {
    machineSerialNumber: string;
    machineInstallationName:string;
    dateTime: Date;
    deposited: Number;
    withdrawn: Number;

    constructor() {
        this.machineSerialNumber = null;
        this.machineInstallationName = null;
        this.dateTime = null;
        this.deposited = 0;
        this.withdrawn = 0
    }

    public parse(obj: any) {
        if (obj.MachineSerialNumber) this.machineSerialNumber = obj.MachineSerialNumber;
        if (obj.MachineInstallationName) this.machineInstallationName = obj.MachineInstallationName;
        if (obj.DateTime) this.dateTime = new Date(obj.DateTime);
        if (obj.Deposited) this.deposited = obj.Deposited;
        if (obj.Withdrawn) this.withdrawn = obj.Withdrawn;
    }
}